if (!customElements.get('lq-product-fetch')) {
  customElements.define(
    'lq-product-fetch',
    class ProductFetch extends HTMLElement {
      constructor() {
        super();
        this.quantity = this.dataset.productQuantity;
      }

      fetchProduct() {
        if (this.classList.contains('loaded')) {
          return;
        }
        this.querySelector('.loading__spinner').classList.remove('hidden');
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(content => {
            const html = document.createElement('div');
            html.innerHTML = content;
            let product = html.querySelector('.shopify-section');
            html.appendChild(product);
            this.innerHTML = html.innerHTML;
            let titleElement = this.querySelector('.product-content__product-details h1');
            if (this.quantity > 1) {
              titleElement.innerHTML = titleElement.innerHTML + ' x' + this.quantity;
            }
            this.classList.add('loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

    }
  );
}

if (!customElements.get('lq-product-tabs')) {
  customElements.define(
    'lq-product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.productTabs = this.querySelectorAll('.product-tabs__titles .product-tabs__title');
        this.productTabsContent = this.querySelectorAll('.product-tabs__content .product-tabs__content-item');

        this.productTabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => this.displayContent(event));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        });
      }

      displayContent(e) {
        const tabNumber = e.target.dataset.tab;
        this.productTabs.forEach((tab) => {
          tab.classList.remove('product-tabs__title--active');
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
        });
        e.target.classList.add('product-tabs__title--active');
        e.target.setAttribute('aria-selected', 'true');
        e.target.setAttribute('tabindex', '0');

        this.productTabsContent.forEach((tabContent) => {
          tabContent.classList.remove('product-tabs__content-item--active');
          if (tabContent.dataset.tab === tabNumber) {
            tabContent.classList.add('product-tabs__content-item--active');
          }
        });
      }

      handleKeydown(e, index) {
        let targetIndex;
        if (e.key === 'ArrowLeft') {
          targetIndex = index - 1;
          if (targetIndex < 0) targetIndex = this.productTabs.length - 1;
        } else if (e.key === 'ArrowRight') {
          targetIndex = index + 1;
          if (targetIndex >= this.productTabs.length) targetIndex = 0;
        } else {
          return;
        }
        this.productTabs[targetIndex].focus();
        this.displayContent({target: this.productTabs[targetIndex]});
      }
    }
  );
}